import React from "react";
import { useNavigate } from "react-router-dom";
import AccountSettings from "../components/forms/AccountSettings";
import CustomerLayout from "../components/layout/CustomerLayout";
import { useAuth } from "../context/AuthContext";

export default function AccountSettingsPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const name = `${user?.first_name || ""} ${user?.last_name || ""}`.trim() || "Patient";
  const initials = name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) || "U";

  return (
    <CustomerLayout title="Profile & Settings" subtitle="Manage your account information">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-14 h-14 bg-[#0d3d2e] rounded-2xl flex items-center justify-center text-white font-black text-xl">
            {initials}
          </div>
          <div>
            <h2 className="text-xl font-black text-gray-900">{name}</h2>
            <p className="text-sm text-gray-500">{user?.email}</p>
          </div>
        </div>
        <AccountSettings />
      </div>
    </CustomerLayout>
  );
}
